import { Outlet } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { VacanciesRequisitionsTable } from 'modules/ats/pages/VacanciesRequisitionPage/VacanciesRequisitionsTable'

const VacanciesRequisitionPage = () => {
  return (
    <ResponsivePage.Body variant="full">
      <VacanciesRequisitionsTable />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default VacanciesRequisitionPage
